import * as React from 'react';
import Animate from 'rc-animate';
import classNames from 'classnames';
import { previewImage, isImageUrl } from './utils';
import Icon from '../icon';
import Tooltip from '../tooltip';
import Progress from '../progress';
import { ConfigConsumer } from '../config-provider';
export default class UploadList extends React.Component {
    constructor() {
        super(...arguments);
        this.handlePreview = (file, e) => {
            const { onPreview } = this.props;
            if (!onPreview) {
                return;
            }
            e.preventDefault();
            return onPreview(file);
        };
        this.handleDownload = (file) => {
            const { onDownload } = this.props;
            if (typeof onDownload === 'function') {
                onDownload(file);
            }
            else if (file.url) {
                window.open(file.url);
            }
        };
        this.handleClose = (file) => {
            const { onRemove } = this.props;
            if (onRemove) {
                onRemove(file);
            }
        };
        this.renderUploadList = ({ getPrefixCls }) => {
            const { prefixCls: customizePrefixCls, items = [], listType, showPreviewIcon, showRemoveIcon, showDownloadIcon, locale, progressAttr, } = this.props;
            const prefixCls = getPrefixCls('upload', customizePrefixCls);
            const list = items.map(file => {
                let progress;
                let icon = <Icon type={file.status === 'uploading' ? 'loading' : 'paper-clip'}/>;
                if (listType === 'picture' || listType === 'picture-card') {
                    if (listType === 'picture-card' && file.status === 'uploading') {
                        icon = <div className={`${prefixCls}-list-item-uploading-text`}>{locale.uploading}</div>;
                    }
                    else if (!file.thumbUrl && !file.url) {
                        icon = (<Icon className={`${prefixCls}-list-item-thumbnail`} type="picture" theme="twoTone"/>);
                    }
                    else {
                        const thumbnail = isImageUrl(file) ? (<img src={file.thumbUrl || file.url} alt={file.name} className={`${prefixCls}-list-item-image`}/>) : (<Icon type="file" className={`${prefixCls}-list-item-icon`} theme="twoTone"/>);
                        icon = (<a className={`${prefixCls}-list-item-thumbnail`} onClick={e => this.handlePreview(file, e)} href={file.url || file.thumbUrl} target="_blank" rel="noopener noreferrer">
              {thumbnail}
            </a>);
                    }
                }
                if (file.status === 'uploading') {
                    // show loading icon if upload progress listener is disabled
                    const loadingProgress = 'percent' in file ? (<Progress type="line" {...progressAttr} percent={file.percent}/>) : null;
                    progress = (<div className={`${prefixCls}-list-item-progress`} key="progress">
            {loadingProgress}
          </div>);
                }
                const infoUploadingClass = classNames({
                    [`${prefixCls}-list-item`]: true,
                    [`${prefixCls}-list-item-${file.status}`]: true,
                    [`${prefixCls}-list-item-list-type-${listType}`]: true,
                });
                const linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
                const removeIcon = showRemoveIcon ? (<Icon type="delete" title={locale.removeFile} onClick={() => this.handleClose(file)}/>) : null;
                const downloadIcon = showDownloadIcon && file.status === 'done' ? (<Icon type="download" title={locale.downloadFile} onClick={() => this.handleDownload(file)}/>) : null;
                const downloadOrDelete = listType !== 'picture-card' && (<span key="download-delete" className={`${prefixCls}-list-item-card-actions ${listType === 'picture' ? 'picture' : ''}`}>
          {downloadIcon && <a title={locale.downloadFile}>{downloadIcon}</a>}
          {removeIcon && <a title={locale.removeFile}>{removeIcon}</a>}
        </span>);
                const listItemNameClass = classNames({
                    [`${prefixCls}-list-item-name`]: true,
                    [`${prefixCls}-list-item-name-icon-count-${[downloadIcon, removeIcon].filter(x => x).length}`]: true,
                });
                const preview = file.url
                    ? [
                        <a key="view" target="_blank" rel="noopener noreferrer" className={listItemNameClass} title={file.name} {...linkProps} href={file.url} onClick={e => this.handlePreview(file, e)}>
              {file.name}
            </a>,
                        downloadOrDelete,
                    ]
                    : [
                        <span key="view" className={listItemNameClass} onClick={e => this.handlePreview(file, e)} title={file.name}>
              {file.name}
            </span>,
                        downloadOrDelete,
                    ];
                const style = {
                    pointerEvents: 'none',
                    opacity: 0.5,
                };
                const previewIcon = showPreviewIcon ? (<a href={file.url || file.thumbUrl} target="_blank" rel="noopener noreferrer" style={file.url || file.thumbUrl ? undefined : style} onClick={e => this.handlePreview(file, e)} title={locale.previewFile}>
          <Icon type="eye-o"/>
        </a>) : null;
                const actions = listType === 'picture-card' && file.status !== 'uploading' && (<span className={`${prefixCls}-list-item-actions`}>
          {previewIcon}
          {file.status === 'done' && downloadIcon}
          {removeIcon}
        </span>);
                let message;
                if (file.response && typeof file.response === 'string') {
                    message = file.response;
                }
                else {
                    message = (file.error && file.error.statusText) || locale.uploadError;
                }
                const iconAndPreview = file.status === 'error' ? (<Tooltip title={message}>
            {icon}
            {preview}
          </Tooltip>) : (<span>
            {icon}
            {preview}
          </span>);
                return (<div className={infoUploadingClass} key={file.uid}>
          <div className={`${prefixCls}-list-item-info`}>{iconAndPreview}</div>
          {actions}
          <Animate transitionName="fade" component="">
            {progress}
          </Animate>
        </div>);
            });
            const listClassNames = classNames({
                [`${prefixCls}-list`]: true,
                [`${prefixCls}-list-${listType}`]: true,
            });
            const animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
            return (<Animate transitionName={`${prefixCls}-${animationDirection}`} component="div" className={listClassNames}>
        {list}
      </Animate>);
        };
    }
    componentDidUpdate() {
        const { listType, items, previewFile } = this.props;
        if (listType !== 'picture' && listType !== 'picture-card') {
            return;
        }
        (items || []).forEach(file => {
            if (typeof document === 'undefined' ||
                typeof window === 'undefined' ||
                !window.FileReader ||
                !window.File ||
                !(file.originFileObj instanceof File || file.originFileObj instanceof Blob) ||
                file.thumbUrl !== undefined) {
                return;
            }
            file.thumbUrl = '';
            if (previewFile) {
                previewFile(file.originFileObj).then((previewDataUrl) => {
                    // Need append '' to avoid dead loop
                    file.thumbUrl = previewDataUrl || '';
                    this.forceUpdate();
                });
            }
        });
    }
    render() {
        return <ConfigConsumer>{this.renderUploadList}</ConfigConsumer>;
    }
}
UploadList.defaultProps = {
    listType: 'text',
    progressAttr: {
        strokeWidth: 2,
        showInfo: false,
    },
    showRemoveIcon: true,
    showDownloadIcon: true,
    showPreviewIcon: true,
    previewFile: previewImage,
};
